@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
  margin-bottom: $spacing-s;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}
